import * as z from "zod";

export const getProductKnowledgePageCount = {
  name: "getProductKnowledgePageCount" as const,
  input: z.object({}),
  output: z.object({ pageCount: z.number() }),
};
